/**
 * Languages offered on the client intake form.
 *
 * Ordered by how often US firms actually need an interpreter (Census ACS
 * "language spoken at home" plus the languages state courts most often
 * certify), then alphabetically. The field stays free-text at the database
 * level, so a firm can still type a language that is not on this list.
 */
export const CLIENT_LANGUAGES: readonly string[] = [
  'English',
  'Spanish',
  'Chinese (Mandarin)',
  'Chinese (Cantonese)',
  'Tagalog',
  'Vietnamese',
  'Arabic',
  'French',
  'Haitian Creole',
  'Korean',
  'Russian',
  'Portuguese',
  'Polish',
  'Italian',
  'German',
  'Hindi',
  'Urdu',
  'Punjabi',
  'Gujarati',
  'Bengali',
  'Japanese',
  'Persian (Farsi)',
  'Amharic',
  'Somali',
  'Swahili',
  'Hebrew',
  'Greek',
  'Armenian',
  'Ukrainian',
  'Romanian',
  'Hmong',
  'Khmer',
  'Lao',
  'Thai',
  'Nepali',
  'Burmese',
  'Turkish',
  'Yoruba',
  'Igbo',
  'American Sign Language',
  'Other',
];

export default CLIENT_LANGUAGES;
